import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue";
import { CalendarEvent } from "@/ts/stores/event";
import { EventRegistrationForm } from "@/ts/components/events";
import { dateString, isPastEvent } from "@/ts/utils/event-utils";
import VueEasyLightbox from "vue-easy-lightbox";
import axios from "axios";

interface Props {
    id?: string;
    event: CalendarEvent;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    id: { type: String, required: false },
    event: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    id?: string;
    event: CalendarEvent;
}

var slugify = require("slugify");


const lightboxIndex = ref<null | number>(null);
const flickrPhotos = ref<string[]>();

/**
 * Computed variables
 */
const isPast = computed<boolean>(() => {
    return isPastEvent(props.event);
});

const images = computed<string[]>(() => {
    let images: string[] = [];
    if (props.event && props.event.acf.media.media_source === "flickr" && flickrPhotos.value) {
        images = flickrPhotos.value;
    } else if (props.event.acf.media.gallery && props.event.acf.media.gallery.length) {
        images = props.event.acf.media.gallery?.map((acfImage) => acfImage.url);
    }
    return images;
});

onMounted(() => {
    if (props.event && props.event.acf.media.media_source === "flickr") {
        axios.get(`/api/flickr-photos?album=${props.event.acf.media.flickr_album_id}`).then((response: { status: number; data: string[] }) => {
            if (response.status === 200 && response.data) {
                flickrPhotos.value = response.data;
            }
        });
    }
});

//console.log(JSON.stringify(props.event, null, 4));

const __returned__ = { slugify, props, lightboxIndex, flickrPhotos, isPast, images, EventRegistrationForm, dateString, VueEasyLightbox }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})